(function (angular) {
	'use strict';

	angular.module('PinMeTo.directives').component('pmtCountryNameDropdown', {
		templateUrl: 'pmtShared/directives/pmtCountryNameDropdown.html',
		controller: Dropdown,
		bindings: {
			selectedValue: '<',
			onSelectedValueChanged: '<',
			allowedCountries: '<'
		}
	});

	Dropdown.$inject = ['countryData'];
	function Dropdown(countryData) {
		var $ctrl = this;
		$ctrl.selectedCountry = { selected: $ctrl.selectedValue };
		$ctrl.countries = [];

		this.compareCountries = function (a, b) {
			return a != null && b != null && a.name === b.name;
		};

		this.showCountryInDropDown = function (x) {
			return x != null ? x.name : 'selected item is undefined!';
		};

		this.$onChanges = function () {
			var update = angular.copy($ctrl.selectedCountry);
			update.selected = $ctrl.selectedValue;
			$ctrl.selectedCountry = update;
		};

		countryData
			.getCountryCodes()
			.then(function (countries) {
				if ($ctrl.allowedCountries && $ctrl.allowedCountries.length) {
					$ctrl.countries = countries.filter(c => $ctrl.allowedCountries.includes(c.alpha2));
				} else {
					$ctrl.countries = countries;
				}
				var tmp = countries.find(function (x) {
					return $ctrl.compareCountries(x, { name: $ctrl.selectedValue });
				});
				if (tmp) {
					$ctrl.selectedValue = tmp;
				}
			})
			.catch(function (err) {
				console.log('failed to get countries', err);
			});
	}
})(window.angular);
